module.exports = __webpack_public_path__ + "azerbaijan.svg?aed905d7c8a11807ebf30ec214a67b7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/azerbaijan.svg
// module id = 99
// module chunks = 10